import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface StoryViewParams {
  slug: string;
}

export const sendGAWabunkaStoryViewEvent = (slug: string) => {
  sendWabunkaGAEvent('story_view', { slug } as StoryViewParams);
};
